const validationsAR = {
  passwordLengthRestriction: 'يجب أن تكون كلمة المرور 8 أحرف على الأقل',
  containsCapitalSmallLetter: 'يجب أن تحتوي كلمة المرور على حرف كبير واحد وحرف صغير واحد على الأقل',
  containsNumber: 'يجب أن تحتوي كلمة المرور على رقم واحد على الأقل',
  containsSpecialCharacter: 'يجب أن تحتوي كلمة المرور على حرف خاص واحد على الأقل [. ،! @ #؟ ]',
  confirmPasswordEmptyField: 'تأكيد كلمة المرور مطلوب',
  passwordsNotMatched: 'كلمة المرور غير متطابقة',
  serviceError: 'هناك خطأ ما',
  emailEmptyField: 'عنوان البريد الإلكتروني مطلوب',
  passwordEmptyField: 'كلمة المرور مطلوبة',
  notFoundEmail: 'الرجاء إدخال البريد الإلكتروني الصحيح',
  incorrectPassword: 'الرجاء إدخال كلمة السر الصحيحة',
  invalidEmail: 'يرجى إدخال عنوان بريد إلكتروني صالح  ',
  invalidPhoneNumber: 'يرجى إدخال رقم هاتف صالح',
  phoneNumberEmptyField: 'رقم الهاتف مطلوب',
  firstNameEmptyField: 'الإسم الأول مطلوب',
  lastNameEmptyField: 'إسم العائلة مطلوب',
  jobTitleEmptyField: 'المسمى الوظيفي مطلوب',
  companyNameEmptyField: 'اسم الشركة مطلوب',
  reasonsForUsingPlatformEmptyField: 'مطلوب أسباب لاستخدام النظام الأساسي',
  codeInvalidInput: 'الرمز غير صحيح. حاول مرة اخرى',
  codeEmptyInput: 'الرجاء إدخال رمز تسجيل الدخول للتحقق',
  invalidCredentials: 'بيانات الاعتماد غير صالحة',
  invalidPhone: 'رقم الهاتف غير صالح',
  invalidJobTitle: 'المسمى الوظيفي مطلوب',
};

export default validationsAR;
